const Constants = {
  defaultSearchInputSelector: 'input[name="s"], input[name="q"]',
  defaultSearchResultsSelector: '.static-snap-search-results',
};

export default Constants;
